import React, { Component } from 'react';
// import { Button } from '../../../components';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { StandardDialog } from '../../dialogs';
import PropTypes from 'prop-types';

class TestCompletedDialog extends Component {
  renderRetryInfo() {
    if (this.props.cardsNotKnownCount == 0) {
      return null;
    }

    if (this.props.selectedExam) {
      return (
        <Typography>
          Sie haben die Prüfung beendet, Sie können ihr Ergebnis unter
          "Zu meinen Ergebnissen" abrufen
        </Typography>
      );
    }

    const progressText = `${this.props.correctAnswersCount} von ${this.props.questionCount} Antworten richtig!`;

    return (
      <div>
        <p style={styles.text}>{progressText}</p>
        {/* <Button
          style={styles.button}
          onClick={this.props.onRestart}
          label=""
          variant="contained"
          color="primary"
          // labelStyle={{ color: '#ffffff' }}
        >Gleich nochmal probieren</Button> */}
      </div>
    );
  }


  render() {
    const dialogTitle = this.props.selectedExam
      ? 'Prüfung abgeschlossen'
      : 'Test abgeschlossen';

    return (
      <StandardDialog
        modal
        open={this.props.open}
        title={dialogTitle}
        titleStyle={styles.text}
      >

        {this.renderRetryInfo()}

        <Button
          style={styles.button}
          onClick={this.props.onTestsSelected}
          label=""
          variant="contained"
          color="primary"
          // style={{ color: '#ffffff' }}
        >Zur Testübersicht</Button>

        <Button
          style={styles.button}
          onClick={this.props.onResultsSelected}
          label=""
          variant="contained"
          color="primary"
          // labelStyle={{ color: '#ffffff' }}
        >Zu meinen Ergebnissen</Button>
      </StandardDialog>
    );
  }
}

TestCompletedDialog.propTypes = {
  open: PropTypes.bool.isRequired,
};

const styles = {
  button: {
    width: '100%',
    marginTop: 20,
    color: '#ffffff',
  },
  text: {
    textAlign: 'center',

  },
};


export default TestCompletedDialog;



// WEBPACK FOOTER //
// ./src/app/main/dialogs/test-completed/test-completed.js